// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#validation
const regex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/);

export const isValidEmail = (email: string): boolean => {
  return regex.test(email);
}